<template><router-view /><modals-container /><div class="demo-notice" role="status">{{ notice }}</div></template>
<script>
import '@/styles/reset.css'
import '@/styles/common.css'
import '@/demo/layout.css'
import { ModalsContainer } from 'vue-final-modal'
export default {
  components: { ModalsContainer },
  data: () => ({ notice: 'PARTNER DEMO · 가상 데이터 / 조회 전용 · 지급·회수·저장 불가' }),
  mounted () { window.addEventListener('partner-demo-disabled', this.showNotice) },
  beforeUnmount () { window.removeEventListener('partner-demo-disabled', this.showNotice) },
  methods: { showNotice (event) { this.notice = event.detail } }
}
</script>
<style>
.demo-notice { position:fixed; z-index:99999; bottom:0; left:0; right:0; padding:10px; text-align:center; background:#153d30; color:#e0ffee; font-size:13px; }
body { padding-bottom:40px; }
</style>
